import styled, { css } from 'styled-components';

import colors from '@front/common/src/utils/colors';
import { toRem } from '@front/common/src/utils/styles';
import { INPUT_HEIGHT } from '@front/common/src/components/input/styles';

import { boxShadow } from './mixins';

export const autocompleteContainerStyle = css`
  position: relative;
  width: 100%;
`;

export const autocompleteDropdownStyle = css`
  ${boxShadow.normal};
  position: absolute;
  background: ${colors.white100};
  border-radius: ${toRem(10)};
  overflow: hidden;
  z-index: 999;
  width: 100%;
  top: ${toRem(INPUT_HEIGHT + 5)};
`;

// normally we try to use a multiple of 5 for the spacing but for this case
// I used 12 on the padding because it's too different from the design otherwise
export const Suggestion = styled.div`
  padding: ${toRem(12)} ${toRem(20)};
  display: flex;
  align-items: center;
  background: ${colors.white100};
  cursor: pointer;

  &:hover,
  &:active {
    background: ${colors.ink10};
  }
`;
